import { Type, Validator } from "./Type";
import DateRangePicker, {
  DateRangePickerProps
} from "../components/Inputs/DateAndTime/DateRangePicker";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { DateTimeRenderer, Required } from "../index";

export const DateRangeComponent = (props: DateRangePickerProps) => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DateRangePicker {...props} />
    </MuiPickersUtilsProvider>
  );
};

export const DateRangeField = (
  props?: Partial<DateRangePickerProps>,
  ...validators: Validator[]
) => {
  const hasRequiredValidator = validators.indexOf(Required) !== -1;

  return new Type({
    // @ts-ignore
    Component: DateRangeComponent,
    PresentationComponent: DateTimeRenderer,
    props: {
      ...props,
      clearable: !hasRequiredValidator
    },
    validators
  });
};
